var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.1042C16.5 14.4909 16.342 14.8619 16.0607 15.1354C15.7794 15.4089 15.3978 15.5625 15 15.5625H3C2.60218 15.5625 2.22064 15.4089 1.93934 15.1354C1.65804 14.8619 1.5 14.4909 1.5 14.1042V3.89583C1.5 3.50906 1.65804 3.13813 1.93934 2.86464C2.22064 2.59115 2.60218 2.4375 3 2.4375H6.75L8.25 4.625H15C15.3978 4.625 15.7794 4.77865 16.0607 5.05214C16.342 5.32563 16.5 5.69656 16.5 6.08333V14.1042Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.125V12.75M6.1875 9.9375H11.8125",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/addFolder.1dd5c83c9c1842674d9a9da0fefd153d.svg";
export { ForwardRef as ReactComponent };